import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppInsightsService {
  private appInsights: ApplicationInsights;
  private isProd: boolean;

  constructor() {
    this.isProd = environment.production;

    if (this.isProd) {
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: 'd3b01c5d-bc00-4ed6-a910-bd94f4b14a99',
        },
      });
      this.appInsights.loadAppInsights();
      this.appInsights.trackPageView();
    }
  }

  public logEvent(name: string, properties?: { [key: string]: any }): void {
    if (this.isProd) {
      this.appInsights.trackEvent({ name: name }, properties);
    }
  }
}
